import { Clickable, Col, Row, Text } from 'components';
import { useOutsideClick } from 'core';
import React, { useRef } from 'react';
import styled from 'styled-components';

const Container = styled.div`
  width: 110px;
  background-color: #fff;
  box-shadow: 0 0 16px rgba(0, 0, 0, 0.1);
  z-index: 0;
  margin: -20px 0 0 -120px;
  height: 20px;
  position: relative;
  visibility: ${(props) => (props.visible ? 'visible' : 'hidden')};
`;
const Menu = ({ dataId, onClick, visible, close, isTier1 }) => {
  const containerRef = useRef();

  useOutsideClick(containerRef, () => visible && close(), []);

  function handleClick() {
    onClick(dataId);
  }

  return (
    <React.Fragment>
      <Container ref={containerRef} visible={visible}>
        <Col>
          <Clickable
            onClick={() => {
              handleClick();
            }}
          >
            <Row noFlex ht="48px" bg="#fff" center>
              <Text med pad="0" marg="0 0 0 16px">
                Edit
              </Text>
            </Row>
          </Clickable>
          {!isTier1 && (
            <Clickable disabled onClick={() => {}}>
              <Row noFlex ht="48px" bg="#fff" center>
                <Text med pad="0" marg="0 0 0 16px">
                  Delete
                </Text>
              </Row>
            </Clickable>
          )}
        </Col>
      </Container>
    </React.Fragment>
  );
};

export default Menu;
